import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(() => {
    try { return JSON.parse(localStorage.getItem('printcorp_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem('printcorp_token');
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await authAPI.me();
      setUser(data.data);
      localStorage.setItem('printcorp_user', JSON.stringify(data.data));
    } catch {
      localStorage.removeItem('printcorp_token');
      localStorage.removeItem('printcorp_user');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await authAPI.login({ email, password });

    // console.log('Réponse login complète :', data);
   // console.log('Token reçu :', data?.data?.token);
   // console.log('User reçu :', data?.data?.user);

    localStorage.setItem('printcorp_token', data.data.token);
    localStorage.setItem('printcorp_user', JSON.stringify(data.data.user));
    setUser(data.data.user);
    return data.data.user;
  };

  const logout = () => {
    localStorage.removeItem('printcorp_token');
    localStorage.removeItem('printcorp_user');
    setUser(null);
  };

  const can = (resource) => {
    if (!user) return false;
    const permissions = {
      super_admin:  ['*'],
      admin:        ['users','clients','products','quotes','invoices','blog','settings','newsletter','orders','mockups'],
      collaborator: ['clients','quotes','invoices','orders','blog'],
      support:      ['clients','orders'],
    };
    const allowed = permissions[user.role] ?? [];
    return allowed.includes('*') || allowed.includes(resource);
  };

  const isAdmin  = () => ['super_admin','admin'].includes(user?.role);
  const isSuperAdmin = () => user?.role === 'super_admin';
  const isStaff  = () => !!user;

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, isAdmin, isSuperAdmin, isStaff }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
